module.exports = __webpack_public_path__ + "static/media/SHUBHAM JI_page-0001.8474ab69.jpg";